export enum TipoProcessoKanbanEnum {
  Orcamento     = 1,
  PedidoDeVenda = 2,
}
